// import { OSS_PATH } from '@/const/basic'
import defLogo from '@/assets/defaultLogo.png'
import dateutil from '@/util/date'

/**
 * @param 获取n位的数字随机数
 */
export const randomn = function(n) {
  if (n > 21) return null
  return parseInt((Math.random() + 1) * Math.pow(10, n - 1))
}

export const getImgUrl = (path, appendStr = '') => {
  if (!path) return defLogo
  else if (path.indexOf('http://') != -1 || path.indexOf('https://') != -1) {
    if (appendStr && path.indexOf('localhost') == -1) {
      return `${path}${appendStr}`
    }
    return path
  }
  return `https://files.kuaipiyun.com/${path}${appendStr}`
}

export const makeImgFileName = (fileName, directoryName) => {
  const directory = directoryName || 'agent'
  if (fileName) {
    return `${directory}/${fileName}_${dateutil.format(new Date(), 'yyyy-MM-dd')}-${randomn(12)}`
  } else {
    return ''
  }
}

export const getImgFileReallyName = (fileName) => {
  if (fileName && fileName.indexOf('_') > -1) {
    if (fileName.split('_')[0].indexOf('/') > -1) {
      return fileName.split('_')[0].split('/')[1]
    } else {
      return fileName
    }
  } else {
    return fileName
  }
}



// WEBPACK FOOTER //
// ./src/lib/utils.js